<div class="chat" [ngClass]="chatClass">
    <div class="chat-avatar">
        <span class="cursor-pointer">
                <ng-container *ngIf="(activity?.signable_type === signableType.USER); else nonSender">
                   <app-user-avatar
                           class="user-avatar"
                           cssVariant="user-avatar-signing-sidebar"
                           [userId]="activity?.signable.id"
                           [shortcutName]="activity?.signable.name | shortName"
                   ></app-user-avatar>

                </ng-container>
                <ng-template #nonSender>
                    <div class="avatar" [style.backgroundColor]="activity?.signable.role_color | alphaBackgroundColor: 0.12" >
                        <div class="avatar-content" [style.color]="activity?.signable.role_color">{{activity?.signable.person | getRecipient | shortName}}</div>
                    </div>
                </ng-template>
        </span>
    </div>
    <div class="chat-body">
        <div class="chat-content" [ngClass]="{'InternalComment': activity?.scope === chatScopeEnum.Internal}">
            <div class="chat-attachment mb-50" *ngIf="activity?.attachment">
                <img *ngIf="is_sender === 0" [src]="activity?.attachment | signingPageImage:roleId | async">
                <img *ngIf="is_sender === 1" [src]="activity.document_id | thumbnail : 'chat_attachment' : activity?.attachment">
            </div>
            <p class="font-small-3">{{ activity?.message }}</p>
        </div>
    </div>
</div>
